import { render } from "./record-modification.vue?vue&type=template&id=356dc806"
import script from "./record-modification.vue?vue&type=script&lang=js"
export * from "./record-modification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__